import type {RouteRecordRaw} from 'vue-router';

export const IndexRoute: RouteRecordRaw = {
    path: '/',
    redirect: '/home',
    name: 'account',
};
